// extracted by mini-css-extract-plugin
export default {"landing":"LandingPage_landing__2a0ho"};